const Stock = {

    // FIELDS
    "category": "Category",
    "search": "Search",
    "quantity": "Quantity",
    "mfg": "MFG",
    "exp": "EXP",
    "remark": "Remark",

    // PAGE HEADER
    "stock": "Stock",
    "stock_availability": "Stock Availability",
    "product": "Product",
    "available_stock": "Available Stock",
    "sold_stock": "Sold Stock",
    "return_stock": "Return Stock",
    "no_variant_data": "No variant data available",
    "no_data_found": "No Data Found",

    // ERROR
    "error_category": "Select Category",
    "error_quantity": "Enter Quantity greater than 0",
    "error_mfg": "Select MFG Month & Year",
    "error_exp": "Select EXP Month & Year",
    "error_rows_required": "Select at least one product row to save stock",
    "no_products_found": "No products found for selected category",

    // TABLE HEADER
    "table_batch_no": "BATCH NO",
    "table_category": "CATEGORY",
    "table_product": "PRODUCT",
    "table_variant": "VARIANT",
    "table_quantity": "QUANTITY",
    "table_mfg": "MFG",
    "table_exp": "EXP",
    "table_fy": "FY",
    "table_remark": "REMARK",

}

export default Stock;